export default __webpack_public_path__ + "static/media/amazon-card.779528d1.svg";